<script setup lang="ts">
import { Icon } from "@toruslabs/vue-components/Icon";
import { Toast } from "@toruslabs/vue-components/Toast";
import { computed, ref, watch } from "vue";

import { useToastStore } from "../../store/toastStore";
// import { userModule } from "@/store/index";
import { TOAST_TYPES } from "../../utils/interfaces";

type TORUS_UI_TOAST_TYPE = "default" | "success" | "danger" | "info";

// const { t } = useI18n();
const toastStore = useToastStore();

withDefaults(
  defineProps<{
    hasNavbar?: boolean;
  }>(),
  {
    hasNavbar: false,
  }
);

const timeoutTimer = ref(0);

const toastMessage = computed(() => {
  return toastStore.toastMessage;
});

const toastIcon = computed(() => {
  if (toastMessage.value.type === TOAST_TYPES.SUCCESS) return "check-circle-solid-icon";
  if (toastMessage.value.type === TOAST_TYPES.ERROR) return "x-circle-solid-icon";
  return "information-circle-solid-icon";
});

const deleteToastMessage = () => {
  toastStore.setToastMessage({ message: "" });
  clearTimeout(timeoutTimer.value);
};

watch(toastMessage.value, (val) => {
  if (val.message) {
    timeoutTimer.value = window.setTimeout(() => {
      deleteToastMessage();
    }, 7000);
  }
});
</script>

<template>
  <Toast
    :open="!!toastMessage.message"
    :variant="toastMessage.type as TORUS_UI_TOAST_TYPE"
    placement="bottom-center"
    class="z-10 mx-auto w-[90%]! smb:w-[375px]!"
  >
    <div class="flex w-full items-center justify-between">
      <Icon :name="toastIcon" class="mr-2 w-5" />
      <p class="flex flex-1 text-sm font-normal capitalize">
        {{ toastMessage.message }}
      </p>
      <Icon name="x-solid-icon" class="mt-[3px] w-5 cursor-pointer" @click="deleteToastMessage" />
    </div>
  </Toast>
</template>
